import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { DragIcon } from "@/shared/icons";
import { AppButton } from "@/shared/Components";
import type { PropsWithChildren, ReactNode } from "react";
import styles from "../styles.module.scss";

type Props = {
  onRemoveClick?: () => void;
  title: string;
  headerAddableNode?: ReactNode;
  children: ReactNode;
  ref: React.ForwardedRef<HTMLDivElement>;
};

export const GridItemContainerDesktop = forwardRef<HTMLDivElement, PropsWithChildren<Props>>(
  ({ children, title, onRemoveClick, headerAddableNode }, ref) => {
    const { t } = useTranslation();

    return (
      <div className={styles.root} ref={ref}>
        <div className={styles.header}>
          <div className={styles.title}>{title}</div>
          <div className={styles["header-right-section"]}>
            {headerAddableNode}
            <AppButton onClick={onRemoveClick} type="link">
              {t("common.hideBlock")}
            </AppButton>
            <div className={styles["drag-handle"]} id="drag-handle">
              <DragIcon />
            </div>
          </div>
        </div>
        {children}
      </div>
    );
  },
);
